import React, { useEffect, useMemo, useState } from "react";
import "./SubUsuarios.css";

const API_BASE = "https://welaunchyou.com.br/crm-wly";

const permissoes = [
  { key: "menu_dashboard", label: "Dashboard", defaultValue: 1 },
  { key: "menu_leads", label: "Leads", defaultValue: 1 },
  { key: "menu_acoes", label: "Ações", defaultValue: 1 },
  { key: "menu_tags", label: "Tags", defaultValue: 1 },
  { key: "menu_whatsapp", label: "WhatsApp", defaultValue: 1 },
  { key: "menu_openai", label: "OpenAI", defaultValue: 0 },
  { key: "menu_meta_ads", label: "Meta Ads", defaultValue: 0 },
  { key: "menu_google_ads", label: "Google Ads", defaultValue: 0 },
  { key: "menu_dados", label: "Dados", defaultValue: 0 },
  { key: "menu_configuracoes", label: "Configurações", defaultValue: 1 },
  { key: "menu_ajuda", label: "Ajuda", defaultValue: 1 },
];

const formInicial = {
  id: null,
  nome: "",
  email: "",
  senha: "",
  status: "ativo",

  menu_dashboard: 1,
  menu_leads: 1,
  menu_acoes: 1,
  menu_tags: 1,
  menu_whatsapp: 1,
  menu_openai: 0,
  menu_meta_ads: 0,
  menu_google_ads: 0,
  menu_dados: 0,
  menu_configuracoes: 1,
  menu_ajuda: 1,
};

function SubUsuarios() {
  const [usuarioLogado, setUsuarioLogado] = useState(null);
  const [usuarioIdAlvo, setUsuarioIdAlvo] = useState("");
  const [subusuarios, setSubusuarios] = useState([]);

  const [form, setForm] = useState(formInicial);

  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");

  const editando = Boolean(form.id);

  const isAdmin = useMemo(() => {
    return usuarioLogado?.tipo_usuario === "master";
  }, [usuarioLogado]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("usuario");
      const usuario = raw ? JSON.parse(raw) : null;

      setUsuarioLogado(usuario);

      if (usuario?.id) {
        setUsuarioIdAlvo(String(usuario.id));
      }
    } catch {
      setUsuarioLogado(null);
    }
  }, []);

  useEffect(() => {
    if (!usuarioLogado?.id) return;

    carregarSubusuarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuarioLogado]);

  const limparMensagens = () => {
    setErro("");
    setSucesso("");
  };

  const montarUrlListagem = () => {
    const params = new URLSearchParams();

    if (isAdmin && usuarioIdAlvo) {
      params.set("usuario_id", usuarioIdAlvo);
    }

    const query = params.toString();

    return `${API_BASE}/subusuarios.php${query ? `?${query}` : ""}`;
  };

  const carregarSubusuarios = async () => {
    limparMensagens();
    setLoading(true);

    try {
      const response = await fetch(montarUrlListagem(), {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.error || "Erro ao carregar subusuários.");
      }

      setSubusuarios(Array.isArray(data.subusuarios) ? data.subusuarios : []);
    } catch (error) {
      setErro(error.message || "Erro ao carregar subusuários.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (campo, valor) => {
    setForm((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const handlePermissao = (campo) => {
    setForm((prev) => ({
      ...prev,
      [campo]: Number(prev[campo]) === 1 ? 0 : 1,
    }));
  };

  const resetarForm = () => {
    setForm(formInicial);
    limparMensagens();
  };

  const editarSubusuario = (subusuario) => {
    limparMensagens();

    setForm({
      id: subusuario.id,
      nome: subusuario.nome || "",
      email: subusuario.email || "",
      senha: "",
      status: subusuario.status || "ativo",

      menu_dashboard: Number(subusuario.menu_dashboard ?? 1),
      menu_leads: Number(subusuario.menu_leads ?? 1),
      menu_acoes: Number(subusuario.menu_acoes ?? 1),
      menu_tags: Number(subusuario.menu_tags ?? 1),
      menu_whatsapp: Number(subusuario.menu_whatsapp ?? 1),
      menu_openai: Number(subusuario.menu_openai ?? 0),
      menu_meta_ads: Number(subusuario.menu_meta_ads ?? 0),
      menu_google_ads: Number(subusuario.menu_google_ads ?? 0),
      menu_dados: Number(subusuario.menu_dados ?? 0),
      menu_configuracoes: Number(subusuario.menu_configuracoes ?? 1),
      menu_ajuda: Number(subusuario.menu_ajuda ?? 1),
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const salvarSubusuario = async (event) => {
    event.preventDefault();

    limparMensagens();

    if (!form.nome.trim()) {
      setErro("Informe o nome do subusuário.");
      return;
    }

    if (!form.email.trim()) {
      setErro("Informe o e-mail do subusuário.");
      return;
    }

    if (!editando && !form.senha.trim()) {
      setErro("Informe uma senha para o subusuário.");
      return;
    }

    setSalvando(true);

    try {
      const payload = {
        nome: form.nome.trim(),
        email: form.email.trim(),
        status: form.status,

        menu_dashboard: Number(form.menu_dashboard),
        menu_leads: Number(form.menu_leads),
        menu_acoes: Number(form.menu_acoes),
        menu_tags: Number(form.menu_tags),
        menu_whatsapp: Number(form.menu_whatsapp),
        menu_openai: Number(form.menu_openai),
        menu_meta_ads: Number(form.menu_meta_ads),
        menu_google_ads: Number(form.menu_google_ads),
        menu_dados: Number(form.menu_dados),
        menu_configuracoes: Number(form.menu_configuracoes),
        menu_ajuda: Number(form.menu_ajuda),
      };

      if (form.senha.trim()) {
        payload.senha = form.senha.trim();
      }

      if (editando) {
        payload.id = form.id;
      }

      const params = new URLSearchParams();

      if (isAdmin && usuarioIdAlvo) {
        params.set("usuario_id", usuarioIdAlvo);
      }

      const query = params.toString();

      const response = await fetch(
        `${API_BASE}/subusuarios.php${query ? `?${query}` : ""}`,
        {
          method: editando ? "PUT" : "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.error || "Erro ao salvar subusuário.");
      }

      setSucesso(data.message || "Subusuário salvo com sucesso.");
      setForm(formInicial);
      await carregarSubusuarios();
    } catch (error) {
      setErro(error.message || "Erro ao salvar subusuário.");
    } finally {
      setSalvando(false);
    }
  };

  const excluirSubusuario = async (subusuario) => {
    const confirmar = window.confirm(
      `Tem certeza que deseja excluir o subusuário "${subusuario.nome}"?`
    );

    if (!confirmar) return;

    limparMensagens();

    try {
      const params = new URLSearchParams();

      if (isAdmin && usuarioIdAlvo) {
        params.set("usuario_id", usuarioIdAlvo);
      }

      const query = params.toString();

      const response = await fetch(
        `${API_BASE}/subusuarios.php${query ? `?${query}` : ""}`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: subusuario.id,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.error || "Erro ao excluir subusuário.");
      }

      setSucesso(data.message || "Subusuário excluído com sucesso.");

      if (form.id === subusuario.id) {
        setForm(formInicial);
      }

      await carregarSubusuarios();
    } catch (error) {
      setErro(error.message || "Erro ao excluir subusuário.");
    }
  };

  const contarMenusLiberados = (subusuario) => {
    return permissoes.reduce((total, item) => {
      return total + (Number(subusuario[item.key]) === 1 ? 1 : 0);
    }, 0);
  };

  return (
    <div className="subusuarios-page">
      <div className="subusuarios-header">
        <div>
          <span className="subusuarios-eyebrow">Controle de acessos</span>
          <h1>Subusuários</h1>
          <p>
            Cadastre atendentes, secretárias ou membros da equipe e escolha quais
            menus cada pessoa poderá visualizar no Nórea CRM.
          </p>
        </div>

        <button
          type="button"
          className="subusuarios-btn subusuarios-btn-secondary"
          onClick={carregarSubusuarios}
          disabled={loading}
        >
          Atualizar
        </button>
      </div>

      {isAdmin && (
        <div className="subusuarios-master-card">
          <div>
            <strong>Modo master</strong>
            <p>
              Informe o ID da conta principal para listar ou criar subusuários
              vinculados a ela.
            </p>
          </div>

          <div className="subusuarios-master-actions">
            <input
              type="number"
              min="1"
              value={usuarioIdAlvo}
              onChange={(e) => setUsuarioIdAlvo(e.target.value)}
              placeholder="ID do usuário"
            />

            <button
              type="button"
              className="subusuarios-btn subusuarios-btn-primary"
              onClick={carregarSubusuarios}
              disabled={loading || !usuarioIdAlvo}
            >
              Carregar
            </button>
          </div>
        </div>
      )}

      {erro && <div className="subusuarios-alert subusuarios-alert-error">{erro}</div>}
      {sucesso && (
        <div className="subusuarios-alert subusuarios-alert-success">{sucesso}</div>
      )}

      <div className="subusuarios-grid">
        <section className="subusuarios-card subusuarios-form-card">
          <div className="subusuarios-card-header">
            <div>
              <h2>{editando ? "Editar subusuário" : "Novo subusuário"}</h2>
              <p>
                {editando
                  ? "Altere os dados e permissões deste acesso."
                  : "Crie um novo acesso vinculado à conta principal."}
              </p>
            </div>

            {editando && (
              <button
                type="button"
                className="subusuarios-btn subusuarios-btn-light"
                onClick={resetarForm}
              >
                Cancelar edição
              </button>
            )}
          </div>

          <form className="subusuarios-form" onSubmit={salvarSubusuario}>
            <div className="subusuarios-form-row">
              <label>
                Nome
                <input
                  type="text"
                  value={form.nome}
                  onChange={(e) => handleChange("nome", e.target.value)}
                  placeholder="Ex: Maria Atendente"
                  required
                />
              </label>

              <label>
                E-mail
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  placeholder="email@dominio.com.br"
                  required
                />
              </label>
            </div>

            <div className="subusuarios-form-row">
              <label>
                {editando ? "Nova senha, opcional" : "Senha"}
                <input
                  type="password"
                  value={form.senha}
                  onChange={(e) => handleChange("senha", e.target.value)}
                  placeholder={
                    editando
                      ? "Preencha apenas se quiser alterar"
                      : "Senha de acesso"
                  }
                  required={!editando}
                  autoComplete="new-password"
                />
              </label>

              <label>
                Status
                <select
                  value={form.status}
                  onChange={(e) => handleChange("status", e.target.value)}
                >
                  <option value="ativo">Ativo</option>
                  <option value="inativo">Inativo</option>
                </select>
              </label>
            </div>

            <div className="subusuarios-permissoes">
              <div className="subusuarios-permissoes-header">
                <h3>Menus liberados</h3>
                <p>Marque os menus que este subusuário poderá visualizar.</p>
              </div>

              <div className="subusuarios-permissoes-grid">
                {permissoes.map((item) => (
                  <label
                    key={item.key}
                    className={`subusuarios-check ${
                      Number(form[item.key]) === 1 ? "is-active" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={Number(form[item.key]) === 1}
                      onChange={() => handlePermissao(item.key)}
                    />

                    <span>{item.label}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="subusuarios-form-actions">
              <button
                type="submit"
                className="subusuarios-btn subusuarios-btn-primary"
                disabled={salvando}
              >
                {salvando
                  ? "Salvando..."
                  : editando
                  ? "Salvar alterações"
                  : "Criar subusuário"}
              </button>

              <button
                type="button"
                className="subusuarios-btn subusuarios-btn-secondary"
                onClick={resetarForm}
                disabled={salvando}
              >
                Limpar
              </button>
            </div>
          </form>
        </section>

        <section className="subusuarios-card subusuarios-list-card">
          <div className="subusuarios-card-header">
            <div>
              <h2>Subusuários cadastrados</h2>
              <p>
                {subusuarios.length === 1
                  ? "1 acesso encontrado"
                  : `${subusuarios.length} acessos encontrados`}
              </p>
            </div>
          </div>

          {loading ? (
            <div className="subusuarios-empty">Carregando subusuários...</div>
          ) : subusuarios.length === 0 ? (
            <div className="subusuarios-empty">
              Nenhum subusuário cadastrado ainda.
            </div>
          ) : (
            <div className="subusuarios-list">
              {subusuarios.map((subusuario) => (
                <article
                  key={subusuario.id}
                  className={`subusuarios-item ${
                    subusuario.status === "ativo" ? "is-active" : "is-inactive"
                  }`}
                >
                  <div className="subusuarios-item-main">
                    <div>
                      <h3>{subusuario.nome}</h3>
                      <p>{subusuario.email}</p>
                    </div>

                    <span className="subusuarios-status">
                      {subusuario.status === "ativo" ? "Ativo" : "Inativo"}
                    </span>
                  </div>

                  <div className="subusuarios-item-meta">
                    <span>
                      {contarMenusLiberados(subusuario)} de {permissoes.length}{" "}
                      menus liberados
                    </span>

                    {subusuario.atualizado_em && (
                      <span>Atualizado em {subusuario.atualizado_em}</span>
                    )}
                  </div>

                  <div className="subusuarios-item-permissoes">
                    {permissoes
                      .filter((item) => Number(subusuario[item.key]) === 1)
                      .map((item) => (
                        <span key={item.key}>{item.label}</span>
                      ))}
                  </div>

                  <div className="subusuarios-item-actions">
                    <button
                      type="button"
                      className="subusuarios-btn subusuarios-btn-light"
                      onClick={() => editarSubusuario(subusuario)}
                    >
                      Editar
                    </button>

                    <button
                      type="button"
                      className="subusuarios-btn subusuarios-btn-danger"
                      onClick={() => excluirSubusuario(subusuario)}
                    >
                      Excluir
                    </button>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}

export default SubUsuarios;